import { useCouponAndModalForms } from '../../../couponAndModalFormsContext';
import { useCouponValidity } from '../couponValidityContext';


import { Container } from './style';

export function InputDatesContainer() {
    const {   
        initialValidityDate, setInitialValidityDate,
        lastValidityDate, setLastValidityDate,
        noEndDate
    } = useCouponValidity()


    //const { couponDatasToCreateOrEdit, setCouponDatasToCreateOrEdit } = useCouponAndModalForms()


    return(
        <Container noEndDate={noEndDate}>
            <input 
                type="date"
                value={initialValidityDate}
                onChange={event => {
                    setInitialValidityDate(event.target.value)
                    // setCouponDatasToCreateOrEdit({...couponDatasToCreateOrEdit, startDate: event.target.value})
                }}
            />

            <p>a</p>

            <input
                type="date"
                className="endDate"
                value={lastValidityDate}
                onChange={event => {
                    setLastValidityDate(event.target.value)
                    // setCouponDatasToCreateOrEdit({...couponDatasToCreateOrEdit, endDate: event.target.value})
                }}
            />
        </Container>
    )
}

